import React, { ReactNode } from 'react';
import { CreateJobStore } from './create-job.store';

const CreateJobContext = React.createContext<CreateJobStore | null>(null);

export const CreateJobProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<CreateJobStore>(() => new CreateJobStore());

   return <CreateJobContext.Provider value={store}>{children}</CreateJobContext.Provider>;
};

export const useCreateJob = () => {
   const ctx = React.useContext(CreateJobContext);
   if (!ctx) {
      throw new Error('useCreateJob must be used inside reateJobProvider');
   }
   return ctx;
};
